angular
  .module 'gym.components'
  .directive 'restrictedContactProfile', ->
    restrict: 'E'
    template: require('templates/components/contacts/restricted_contact_profile.html.slim')
    scope:
      contact: '='
      permissions: '='
